cockpitApp.directive('flightOverview', function () {
  return {
    restrict: 'E',
    replace: true,
    templateUrl: '/element/flight/overview',
    controllerAs: 'flightOverviewCtrl',
    controller: 'flightOverviewController'
  };
});
